import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface VendorItem {
  value: number | null
  label: string
}

interface invoiceFilter {
  queryParams: string
  searchFilter: string
  currentPage: number
  pageSize: number
  dateFrom: string
  dateTo: string
  selectedVendor: VendorItem
}

const initialState: invoiceFilter = {
  queryParams: '',
  searchFilter: '',
  currentPage: 1,
  pageSize: 50,
  dateFrom: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
  dateTo: new Date().toISOString().split('T')[0],
  selectedVendor: {value: null, label: 'All Vendor'},
}

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setQueryParams(state, action: PayloadAction<string>) {
      state.queryParams = action.payload
    },
    setSearchFilter(state, action: PayloadAction<string>) {
      state.searchFilter = action.payload
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload
    },
    setDateFrom(state, action: PayloadAction<string>) {
      state.dateFrom = action.payload
    },
    setDateTo(state, action: PayloadAction<string>) {
      state.dateTo = action.payload
    },
    setSelectedVendor: (state, action: PayloadAction<VendorItem>) => {
      state.selectedVendor = action.payload
    },
    resetFilters(state) {
      state.queryParams = ''
      state.searchFilter = ''
      state.dateFrom = new Date(new Date().setDate(new Date().getDate() - 7))
        .toISOString()
        .split('T')[0]
      state.dateTo = new Date().toISOString().split('T')[0]
      state.currentPage = 1
      state.pageSize = 10
      state.selectedVendor = {value: null, label: 'All Vendor'}
    },
  },
})

export const {
  setQueryParams,
  setSearchFilter,
  setCurrentPage,
  setPageSize,
  setDateFrom,
  setDateTo,
  resetFilters,
  setSelectedVendor,
} = invoiceSlice.actions

export default invoiceSlice.reducer
